module.exports = __webpack_public_path__ + "static/media/title-bg-20.3ed47b87.jpg";